import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var DribbbleWithCircle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.26 9.982c.033-.012.068-.021.103-.031a14.738 14.738 0 00-.279-.584c-1.88.557-3.68.562-4.001.557-.003.025-.003.051-.003.076 0 .945.34 1.853.958 2.566.206-.332 1.298-1.961 3.222-2.584zm-2.637 3.131a3.913 3.913 0 003.871.512 16.511 16.511 0 00-.822-2.922c-2.121.75-2.922 2.162-3.049 2.41zm4.932-6.086a3.92 3.92 0 00-3.405-.853 20.08 20.08 0 011.421 2.223c1.283-.493 1.863-1.204 1.984-1.37zm-2.85 1.637A23.654 23.654 0 008.29 6.473a3.938 3.938 0 00-2.113 2.658h.017c.406 0 1.849-.033 3.511-.467zm1.809 1.832c.465 1.293.679 2.367.74 2.711a3.933 3.933 0 001.609-2.543 5.81 5.81 0 00-1.592-.221c-.258 0-.513.018-.757.053zM10 .4C4.698.4.4 4.698.4 10s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6S15.302.4 10 .4zm0 14.297A4.703 4.703 0 015.301 10 4.703 4.703 0 0110 5.301 4.704 4.704 0 0114.698 10 4.702 4.702 0 0110 14.697zm.922-5.623c.087.18.168.357.242.531l.071.17c.277-.033.573-.049.882-.049a9.72 9.72 0 011.801.172 3.93 3.93 0 00-.852-2.34c-.16.206-.818.963-2.144 1.516z"
  }));
});
DribbbleWithCircle.displayName = 'DribbbleWithCircle';
export var DribbbleWithCircleDimensions = {
  height: 20,
  width: 20
};